import React from 'react';
import { usePermissions } from "./usePermissions.js";

export const Can = ({ permission, children, fallback = null }) => {


    const { getPermission } = usePermissions();

    if (!permission) {
        return <>{children}</>;
    }

    const result = getPermission(permission);

    if (!result) {
        console.warn(`[Permissions] Clé "${permission}" non trouvée`);
        return <>{fallback}</>;
    }

    if (result.allowed) {
        return <>{children}</>;
    }

    if (result.disabledOnly) {
        return <div style={{ pointerEvents: 'none', opacity: 0.5 }}>{children}</div>;
    }

    return <>{fallback}</>;
  };